t = require('app/scripts/views/internal/teacup-with-helpers')('date_picker')

module.exports = t.renderable ({ canRemove }) ->
  t.div '.datepicker-select.u-clearfix', ->

    t.div '.datepicker-select-date', ->
      t.label '.datepicker-select-label', ->
        t.format 'date'
        t.input '.datepicker-select-input.js-dpicker-date-input.js-autofocus', { type: 'text', placeholder: t.l('enter-date'), tabindex: 101 }

    t.div '.datepicker-select-time', ->
      t.label '.datepicker-select-label', ->
        t.format 'time'
        t.input '.datepicker-select-input.js-dpicker-time-input', { type: 'text', placeholder: t.l('enter-time'), tabindex: 102 }

  t.div '.pickers.js-dpicker-cal'

  t.div '.datepicker-confirm-btns', ->
    t.input '.primary.wide.confirm',
      type: 'submit'
      value: t.l('save')
      tabindex: 103

    if canRemove
      t.button '.negate.remove-date.js-remove-date', { type: 'button', tabindex: 104 }, ->
        t.format 'remove'
